:host {
  display: inline-flex;
  position: relative;
  align-items: flex-start;
  width: fit-content;
  --md-focus-ring-width: 0;
  --md-focus-ring-color: transparent;

  // themable input variables
  --_omk-checkbox-label-color: var(--omk-checkbox-label-color, var(--omk-colour-text-primary-resting));
  --_omk-checkbox-disabled-label-color: var(--omk-checkbox-disabled-label-color, var(--omk-colour-text-disabled-resting));
  --_omk-checkbox-validation-message-color: var(--omk-checkbox-validation-message-color, var(--omk-colour-text-danger-resting));
  --_omk-checkbox-outline-color: var(--omk-checkbox-outline-color, var(--omk-colour-icon-primary-resting));
  --_omk-checkbox-outline-error-color: var(--omk-checkbox-outline-error-color, var(--omk-colour-icon-danger-resting));
  --_omk-checkbox-disabled-outline-color: var(--omk-checkbox-disabled-outline-color, var(--omk-colour-icon-disabled-disabled));
  --_omk-checkbox-icon-background-color: var(--omk-checkbox-icon-background-color, var(--omk-colour-icon-active-resting));
  --_omk-checkbox-icon-foreground-color: var(--omk-checkbox-icon-foreground-color, var(--omk-colour-icon-inverse-resting));
  --_omk-checkbox-selected-hover-icon-foreground-color: var(--omk-checkbox-selected-hover-icon-foreground-color, var(--omk-colour-container-primary-focus));
  --_omk-checkbox-disabled-icon-background-color: var(--omk-checkbox-disabled-icon-background-color, var(--omk-colour-icon-disabled-disabled));
  --_omk-checkbox-label-element-gap: var(--omk-checkbox-label-element-gap, var(--omk-dimension-spacing-xxsmall));
  --_omk-checkbox-padding: var(--omk-checkbox-padding, 3px);
  --_omk-checkbox-state-layer-shape: var(--omk-checkbox-state-layer-shape, var(--omk-dimension-border-radius-xxxsmall));
  --_omk-checkbox-state-layer-size: var(--omk-checkbox-state-layer-size, 24px);

  --_omk-checkbox-error-state-layer-colour: var(--omk-checkbox-error-state-layer-colour, var(--omk-colour-container-danger-hover));
  --_omk-checkbox-hover-state-layer-colour: var(--omk-checkbox-hover-state-layer-colour, var(--omk-colour-container-primary-hover));
  --_omk-checkbox-focus-state-layer-colour: var(--omk-checkbox-focus-state-layer-colour, var(--omk-colour-container-primary-focus));

  --md-sys-color-error: var(--_omk-checkbox-validation-message-color);
  --md-sys-color-primary: var(--_omk-checkbox-icon-background-color);
  --md-checkbox-container-size: 18px;
  --md-checkbox-outline-color: var(--_omk-checkbox-outline-color);

  --md-checkbox-disabled-container-color: var(--_omk-checkbox-disabled-outline-color);
  --md-checkbox-disabled-container-opacity: 1;
  --md-checkbox-disabled-outline-color: var(--_omk-checkbox-disabled-outline-color);

  --md-checkbox-disabled-container-opacity: 1;
  --md-checkbox-disabled-icon-color: var(--_omk-checkbox-disabled-icon-background-color);
  --md-checkbox-disabled-icon-opacity: 1;
  --md-checkbox-outline-color: var(--_omk-checkbox-outline-color);
  --md-checkbox-hover-outline-color: var(--_omk-checkbox-outline-color);
  --md-checkbox-pressed-outline-color: var(--_omk-checkbox-outline-color);
  --md-checkbox-focus-outline-color: var(--_omk-checkbox-outline-color);
  --md-checkbox-disabled-outline-color: var(--_omk-checkbox-disabled-outline-color);
  --md-checkbox-selected-icon-color: var(--_omk-checkbox-icon-foreground-color);
  --md-checkbox-selected-disabled-icon-color: var(--_omk-checkbox-icon-foreground-color);
  --md-checkbox-selected-hover-icon-color: var(--_omk-checkbox-selected-hover-icon-foreground-color);
  --md-checkbox-selected-focus-icon-color: var(--_omk-checkbox-selected-hover-icon-foreground-color);
  --md-checkbox-selected-pressed-icon-color: var(--_omk-checkbox-icon-foreground-color);

  --md-checkbox-state-layer-shape: var(--_omk-checkbox-state-layer-shape);
  --md-checkbox-state-layer-size: var(--_omk-checkbox-state-layer-size);

  // inner components
  --omk-label-color: var(--_omk-checkbox-label-color);
  --omk-validation-error-color: var(--_omk-checkbox-validation-message-color);

  // container classes
  gap: var(--_omk-checkbox-label-element-gap);
  md-checkbox {
    // stop it getting squashed if the label or error message is long enough to wrap
    flex-shrink: 0;
    padding: var(--_omk-checkbox-padding);
  }
}

:host([disabled]) {
  pointer-events: none;
}

:host(.touched:invalid) {
  // Material is supposed to do this for us, but doesn't actually have any :invalid styling for checkboxes as of version 1.1.1
  --_omk-checkbox-outline-color: var(--_omk-checkbox-outline-error-color);

  .halo:hover, .halo.keyboard-focus {
    background-color: var(--_omk-checkbox-error-state-layer-colour);
  }
}

.halo {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: var(--_omk-checkbox-state-layer-size);
  height: var(--_omk-checkbox-state-layer-size);
  border-radius: var(--_omk-checkbox-state-layer-shape);

  &:hover {
    background-color: var(--_omk-checkbox-hover-state-layer-colour);
  }

  &:hover.has-value {
    background-color: var(--_omk-checkbox-focus-state-layer-colour);
  }

  &.keyboard-focus {
    background-color: var(--_omk-checkbox-focus-state-layer-colour);
  }
}
